import LocalShippingIcon from "@mui/icons-material/LocalShipping";

import { registerNavSection } from "./shell/navigation";

registerNavSection({ key: "purchasing", spoke: "purchasing", title: "Purchasing", icon: LocalShippingIcon, order: 46, entries: [
  { label: "Purchase orders", to: "/app/purchasing/orders", permission: "purchasing.order.view" },
  { label: "New PO", to: "/app/purchasing/orders/new", permission: "purchasing.order.create" },
  { label: "Requisitions", to: "/app/purchasing/requisitions", permission: "purchasing.requisition.view" },
  { label: "Supplier RFQs", to: "/app/purchasing/rfqs", permission: "purchasing.rfq.view" },
  { label: "Receiving schedule", to: "/app/purchasing/receiving", permission: "purchasing.order.view" },
  { label: "Expediting", to: "/app/purchasing/expediting", permission: "purchasing.order.view" },
  { label: "Blanket POs", to: "/app/purchasing/blanket-pos", permission: "purchasing.blanket.view" },
  { label: "Supplier scorecards", to: "/app/purchasing/scorecards", permission: "purchasing.analytics.view" },
  { label: "Approved vendors", to: "/app/masterdata/approved-vendors", permission: "purchasing.approved_vendor.view" },
  { label: "Vendors", to: "/app/masterdata/vendors", permission: "purchasing.vendor.view" },
] });
